import { PADDING_ADD_MORE_BUTTON } from '@photosi/rn-components/button-add-mobile/ButtonAddMobile.constants';
import React, { useState } from 'react';
import { LayoutDimensionsContext } from 'src/contexts/LayoutDimensionsContext';

interface LayoutDimensionsProviderProps {
  children: React.ReactNode;
}

export const LayoutDimensionsProvider: React.FC<LayoutDimensionsProviderProps> = ({ children }) => {
  const [bottomBarV3Height, setBottomBarV3Height] = useState<number>(0);
  const [addMoreButtonHeight, setAddMoreButtonHeight] = useState<number>(0);

  const toastNotificationBottom = bottomBarV3Height + 2 * PADDING_ADD_MORE_BUTTON + addMoreButtonHeight;

  return (
    <LayoutDimensionsContext.Provider
      value={{
        bottomBarV3Height,
        setBottomBarV3Height,
        addMoreButtonHeight,
        setAddMoreButtonHeight,
        toastNotificationBottom,
      }}
    >
      {children}
    </LayoutDimensionsContext.Provider>
  );
};
